/* ============================================================================
 * Meadow & Bark — Boardwalk Giveaway
 * Landing-page logic: capture ambassador slug + submit lead to Klaviyo.
 *
 * No backend / no private keys. Uses Klaviyo's CLIENT API with the PUBLIC
 * Site ID only (safe to expose). See CLAUDE_CODE_BRIEF_ambassador_program.md.
 * ==========================================================================*/
(function () {
  'use strict';

  /* ── CONFIG — the only values to fill on go-live ────────────────────────
   * companyId : Klaviyo Public API Key / Site ID (public, safe in client JS).
   *             CONFIRM which account is live: V2PsrN vs SFGG39.
   * listId    : Klaviyo giveaway List ID — single opt-in list. Ask specialist.
   * ---------------------------------------------------------------------- */
  var CONFIG = {
    companyId: 'V2PsrN',                 // confirmed live account
    listId: 'Vu4EvP',                    // "Summer Giveaway Entries" (single opt-in)
    revision: '2026-04-15',
    customSource: 'Boardwalk Giveaway',
    sourceTag: 'boardwalk_giveaway',
    thankYouUrl: 'thank-you.html',       // Shopify: '/pages/summer-giveaway-thank-you'
    registryUrl: 'assets/data/ambassadors.json', // Shopify: file passed via data-registry
    storeUrl: 'https://www.meadowandbark.com/',  // base for shop_link (sca_ref appended)
    fallbackCoupon: 'GIVEAWAY15'         // coupon sent when the entrant has NO ambassador
  };

  var STORAGE_KEY = 'mb_amb';

  // Registry (slug → coupon_code + sca_ref), loaded once on DOMContentLoaded.
  var registry = null;
  var registryReady = Promise.resolve();

  /* ── 1. Capture the ambassador identifier (§5.1) ────────────────────────
   * Read utm_content once on load; persist in localStorage + cookie so it
   * survives navigation / reload / a cleaned URL by submit time. */
  (function captureAmbassador() {
    try {
      var amb = new URLSearchParams(window.location.search).get('utm_content');
      if (!amb) return;
      amb = amb.toLowerCase().trim();
      try { localStorage.setItem(STORAGE_KEY, amb); } catch (e) {}
      document.cookie = STORAGE_KEY + '=' + encodeURIComponent(amb) +
        ';path=/;max-age=' + (60 * 60 * 24 * 90) + ';SameSite=Lax';
    } catch (e) {}
  })();

  function getAmbassador() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      if (v) return v;
    } catch (e) {}
    var m = document.cookie.match(/(?:^|;\s*)mb_amb=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  window.MB_getAmbassador = getAmbassador; // used by thank-you page too

  /* ── 2. Helpers ─────────────────────────────────────────────────────────*/
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Very light US-centric normaliser to E.164. Leaves already-plus numbers be.
  function toE164(raw) {
    if (!raw) return '';
    var s = raw.trim();
    if (s.charAt(0) === '+') return s.replace(/[^\d+]/g, '');
    var digits = s.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;             // US 10-digit
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return digits ? '+' + digits : '';
  }

  /* ── 3. Wire up the form ────────────────────────────────────────────────*/
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('.giveaway__form');
    if (!form) return;

    // Shopify: config is injected via data-* from section settings (theme
    // editor), so nobody edits JS. Falls back to CONFIG for the prototype.
    if (form.dataset.klaviyoCompany) CONFIG.companyId = form.dataset.klaviyoCompany.trim();
    if (form.dataset.klaviyoList) CONFIG.listId = form.dataset.klaviyoList.trim();
    if (form.dataset.thankyouUrl) CONFIG.thankYouUrl = form.dataset.thankyouUrl.trim();
    if (form.dataset.registry) CONFIG.registryUrl = form.dataset.registry.trim();
    if (form.dataset.storeUrl) CONFIG.storeUrl = form.dataset.storeUrl.trim();
    if (form.dataset.fallbackCoupon) CONFIG.fallbackCoupon = form.dataset.fallbackCoupon.trim();

    // Load the registry so we can attach the ambassador's coupon + shop link.
    registryReady = fetch(CONFIG.registryUrl)
      .then(function (r) { return r.json(); })
      .then(function (d) { registry = d; })
      .catch(function (e) { console.error('[giveaway] registry load failed:', e); });

    // Fill the hidden ambassador field for transparency / any theme tooling.
    var ambField = form.querySelector('[name="ambassador"]');
    if (ambField) ambField.value = getAmbassador();

    var submitBtn = form.querySelector('[type="submit"]');
    var errEl = form.querySelector('.form__error');

    // Show/clear an inline error message (replaces browser alert()).
    function showError(msg) {
      if (!errEl) { if (msg) alert(msg); return; } // fallback if markup missing
      errEl.textContent = msg || '';
      if (msg) errEl.removeAttribute('hidden');
      else errEl.setAttribute('hidden', '');
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      showError('');

      // Honeypot: real users never fill this. Silently "succeed" for bots.
      var hp = form.querySelector('[name="mb_hp"]');
      if (hp && hp.value.trim() !== '') { redirectToThankYou(); return; }

      var data = readForm(form);

      // Client-side validation (server-side re-validation isn't possible here;
      // Klaviyo enforces its own on the API side).
      var err = validate(data);
      if (err) { showError(err); return; }

      setLoading(true);
      registryReady
        .then(function () {
          enrichFromRegistry(data);   // attach coupon + shop_link (or fallbacks)
          return submitLead(data);
        })
        .then(function () { redirectToThankYou(); })
        .catch(function (e) {
          // Klaviyo returned a hard error. Don't trap the user — let them
          // through to the thank-you page (lead can still be recovered), but
          // surface it in the console for debugging.
          console.error('[giveaway] Klaviyo submit failed:', e);
          redirectToThankYou();
        });
    });

    function setLoading(on) {
      if (!submitBtn) return;
      submitBtn.disabled = on;
      submitBtn.style.opacity = on ? '0.6' : '';
    }
  });

  function readForm(form) {
    function val(sel) { var el = form.querySelector(sel); return el ? el.value.trim() : ''; }
    function checked(sel) { var el = form.querySelector(sel); return !!(el && el.checked); }
    var phoneRaw = val('#phone');
    return {
      firstName: val('#fname'),
      lastName: val('#lname'),
      email: val('#email'),
      phone: toE164(phoneRaw),
      phoneDigits: phoneRaw.replace(/\D/g, ''),
      mbOptin: checked('#consent-mb'),          // email + SMS for Meadow & Bark
      partnerOptin: checked('#consent-partners'),
      ambassador: getAmbassador()
    };
  }

  // Resolve the ambassador's coupon + shop link from the registry.
  // No/unknown slug → fallback coupon + plain store URL (no attribution).
  function enrichFromRegistry(d) {
    var amb = (registry && d.ambassador) ? registry[d.ambassador] : null;
    d.coupon = (amb && amb.coupon_code) ? amb.coupon_code : CONFIG.fallbackCoupon;
    d.shopLink = (amb && amb.sca_ref)
      ? CONFIG.storeUrl + (CONFIG.storeUrl.indexOf('?') > -1 ? '&' : '?') + 'sca_ref=' + amb.sca_ref
      : CONFIG.storeUrl;
  }

  function validate(d) {
    if (!d.firstName || !d.lastName) return 'Please enter your first and last name.';
    if (!EMAIL_RE.test(d.email)) return 'Please enter a valid email address.';
    if (d.phoneDigits.length !== 10) return 'Please enter a valid 10-digit phone number.';
    // The Meadow & Bark consent box is required; the partner box is OPTIONAL.
    if (!d.mbOptin) return 'Please tick the Meadow & Bark consent box to enter.';
    return '';
  }

  /* ── 4. Submit to Klaviyo (single client-subscription call) ─────────────*/
  function submitLead(d) {
    // Checkbox 1 (mbOptin) = email + SMS marketing consent for Meadow & Bark.
    var subscriptions = {};
    if (d.mbOptin) {
      subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } };
      if (d.phone) subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }

    var profileAttrs = {
      email: d.email,
      first_name: d.firstName,
      last_name: d.lastName,
      properties: {
        ambassador: d.ambassador || '',
        source: CONFIG.sourceTag,
        mb_optin: d.mbOptin,
        partner_consent: d.partnerOptin,
        giveaway_coupon: d.coupon || '',
        shop_link: d.shopLink || CONFIG.storeUrl
      },
      subscriptions: subscriptions
    };
    if (d.phone) profileAttrs.phone_number = d.phone;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: CONFIG.customSource,
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: {
          list: { data: { type: 'list', id: CONFIG.listId } }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' +
      encodeURIComponent(CONFIG.companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'revision': CONFIG.revision
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok && res.status !== 202) {
        return res.text().then(function (t) {
          throw new Error('HTTP ' + res.status + ' ' + t);
        });
      }
      return res;
    });
  }

  function redirectToThankYou() {
    window.location.href = CONFIG.thankYouUrl;
  }

  /* ── Hero "show participating partners" toggle ──────────────────────────*/
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('.hero__toggle');
    var rest = document.getElementById('mb-hero-rest');
    if (!toggle || !rest) return;
    toggle.addEventListener('click', function () {
      var show = rest.hasAttribute('hidden');
      if (show) {
        rest.removeAttribute('hidden');
        toggle.textContent = 'Show less';
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        rest.setAttribute('hidden', '');
        toggle.textContent = 'Show more';
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ── "How to Enter" scroll-reveal ───────────────────────────────────────
   * Progressive enhancement: only when IntersectionObserver exists do we add
   * .js-anim (which hides the pieces via CSS); then .is-in plays the reveal.
   * No JS / no IO → the section renders fully visible. */
  document.addEventListener('DOMContentLoaded', function () {
    var enter = document.querySelector('.enter');
    if (!enter || !('IntersectionObserver' in window)) return;
    enter.classList.add('js-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          enter.classList.add('is-in');
          io.disconnect();
        }
      });
      // threshold 0 + a bottom margin fires as soon as the section's top
      // scrolls into view — reliable even when the section is taller than
      // the viewport (a high threshold could never be reached on mobile).
    }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
    io.observe(enter);
  });
})();
